export const app_i18n = {
  text1:
    "Escaneie o verso do seu documento de identidade ou a página do passaporte onde está a sua foto",
  text2: "Está com problemas no scanner?",
  text3: "Tentar novamente",
  text4: "Processo manual",
  text5: "Bem-vindo(a)!!",
  text6: "Selecione a data da hospedagem",
  text7: "Seu e-mail",
  text8: "Continuar",
  text9: "Vamos lá! Quase terminando",
  text10: "Bem-vindo(a)",
  text11: "Bem-vindo(a)",
  text12: "Telefone",
  text13:
    "Para continuar com o processo, você precisa aceitar nossos termos e condições.",
  text14: "Aceito os termos e condições",
  text15: "Continuar",
  text16: "Você pode assinar no quadro cinza que aparece na tela",
  text17: "Limpar",
  text18: "Salvar assinatura",
  text19: "Por favor, faça a sua assinatura",
  text20: "Check-in concluído com sucesso",
  text21:
    "Muito obrigado, enviamos uma cópia do documento assinado para o seu WhatsApp",
  text22: "Precisa fazer outro check-in?",
  text23: "Recomeçar",
  text24: "Bem-vindo(a)  🤗",
  text25: "😃 Por favor, insira os seguintes dados",
  text26: "Nome",
  text27: "Sobrenome",
  text28: "Selecione o gênero",
  text29: "Gênero",
  text30: "Masculino",
  text31: "Feminino",
  text32: "Data de nascimento",
  text33: "Vamos lá! Quase lá 😉",
  text34: "Selecione a data da hospedagem.",
  text35: "E-mail",
  text36: "Insira o documento de identidade",
  text37: "Tipo de documento",
  text38: "Documento de identidade",
  text39: "PASSAPORTE",
  text40: "Insira o número do documento",
  text41: "Você precisa selecionar um país",
  // here
  text42: "Países",
  text43: "Lista de serviços disponíveis na hospedagem",
  text44: "Carregando serviços ...",
  text45: "Nenhum serviço disponível",
  text46: "Solicitação de serviço enviada com sucesso",
  text47: "Um atendente entrará em contato para finalizar a solicitação do serviço.",
  text48: "Voltar",
  text49:
    "Solicitação de serviço enviada com sucesso, um supervisor entrará em contato em breve.",
  text50: "Preço",
  text51: "Descrição do serviço",
  text52: "Solicitar",
  text53: "Enviar solicitação de serviço",
  text54: "Ao enviar a solicitação, um supervisor entrará em contato com você",
  text55: "Enviar",
  text56: "Solicitação de serviço enviada com sucesso.",
  text57: "Erro, não foi possível solicitar o serviço",
  text58: "Enviando os dados do check-in, aguarde...",
  text59: "Carregando...",
  text60: "concluiu o check-in com sucesso.",
  text61: `🎁 Clique aqui para ver todos os nossos serviços disponíveis no hotel`,
  text62: "Registro de entrada",
  text63: "Prefiro não dizer",
  text64: "Outro",
  text65: "País",
  text66: "Erro",
  text67: "Hospedagem desativada.",
  text68: "O proprietário desativou os check-ins.",
  text69: "Selecione a data",
  text70: "De - Até",
  text71: "Selecione uma opção",
  text72: "Selecione o país *",
  text73: "Tem certeza de que deseja reiniciar o processo",
  text74: "Você perderá os dados salvos",
  text75: "Dados do check-in",
  text76: "Assinatura do check-in",
  text77: "Assinado",
  text78: "Bem-vindo(a)",
  text79: "Desculpe, ocorreu um erro ao sair",
  text80: "Cancelar o processo.",
  text81:
    "Criar a primeira hospedagem é obrigatório para o bom funcionamento do sistema.",
  text82: "Cancelar e sair",
  text83: "Continuar editando",
  text84: "Buscar...",
  text85: "Nenhum registro encontrado",
  text86: "Anterior",
  text87: "Próximo",
  text88: "Deseja tentar novamente ou fazer o processo manual?",
  text89: "Carregando ...",
  text90: "Serviços",
  text91: "Data de emissão do documento",
  text92: "O campo Data de emissão do documento é obrigatório",
  p93: `carregando seu...`,
  p94: `Dados da reserva`,
  p95: `Bem-vindo(a)`,
  p96: `Para continuar com o check-in, por favor insira os seguintes
    dados:`,
  p97: `Este processo é uma demonstração, nenhum dos seus dados será salvo`,
  p98: `Código de segurança:`,
  p99: `Código de segurança da hospedagem`,
  p101: `Insira o código de segurança`,
  p102: `O código de segurança está incorreto, por favor verifique e tente
    novamente.`,
  p103: `Ou você também pode`,
  p104: `Filtrar por código de check-in`,
  p105: `Continuar`,
  p106: `Código de check-in`,
  p107: `Insira o código de check-in`,
  p108: `O código de check-in não está registrado em nossa plataforma, por favor verifique e tente novamente.`,
  p109: `Insira o código da hospedagem`,
  p110: `Check-in ecológico`,
  p111: `Bem-vindo(a)!`,
  p112: `Tenha seu`,
  p112_1: `Documento de identidade ou Passaporte`,
  p112_2: `em mãos para prosseguir`,
  p113: `Você precisará aceitar as`,
  p114: ` permissões de câmera 📷`,
  p115: ` elas são necessárias para que nosso scanner funcione corretamente.`,
  p116: `Continuar`,
  p117: `Selecione o idioma`,
  p118: `Insira o código de segurança`,
  p119: `Escaneie a página do seu passaporte ou o verso do seu documento de identidade.`,
  p120: `Documento de identidade`,
  p121: `Documento`,
  p122: `ou a página do seu passaporte onde está a sua foto`,
  p123: `Para usar o scanner, é necessário conceder as permissões correspondentes
    à câmera.`,
  p124: `Verificação de segurança ​🔐`,
  p125: `Para verificar seu número, enviamos um código para o seu`,
  p126: `WhatsApp`,
  p127: `Insira aqui:`,
  p128: `Insira o código`,
  p129: `Código incorreto, por favor verifique e tente novamente`,
  p130: `Voltar`,
  p131: `Continuar`,
  p132: `Data de entrada`,
  p133: `Data de saída`,
  p134: `Data de validade`,
  p135: `Nacionalidade`,

  p136: `Ao clicar`,
  p137: ` você concorda em assinar o formulário com seu nome, o contrato de aluguel por temporada`,
  p138: `Políticas de privacidade`,
  p139: `Salvar assinatura`,
  p140: `Informações da reserva`,
  p141: `RESERVA:`,
  p142: `Entrada`,
  p143: `Saída`,
  p144: `Pagar`,
  p145: `Pago`,
  p146: `Verificando pagamento`,
  p147: `Check-in`,
  p148: `Reserva`,
  p149: `Serviços`,
  p150: `VERIFICAÇÃO DE IDENTIDADE`,
  p151: `Envie uma selfie do seu rosto, com boa iluminação por favor`,
  p152: `Nesta tela você pode enviar uma foto da <strong>frente do seu documento`,
  p153: `Nesta tela você pode enviar uma foto do <strong>verso do seu documento`,
  p154: `Abrir câmera`,
  p155: `Tirar novamente`,
  p156: `Verificar identidade`,
  p157: `Continuar`,
  p158: `Erro ao verificar sua identidade.`,
  p159: `Por favor, tente novamente.
    Você pode tirar as fotos em um local bem iluminado e centralizar bem o documento.`,
  p160: `Processo obrigatório*`,
  p161: `Tentar novamente`,
  p162: `Verificando identidade.`,
  p163: `Por favor, aguarde ....`,
  p164: `Identidade verificada com sucesso`,
  p165: `Você verificou sua identidade 🪪 com sucesso, quase terminando o processo de check-in 😎`,
  p166: `Sob consulta`,
  p167: `Para solicitar este serviço, você precisa fazer o seu check-in.`,
  p168: `Progresso`,
  p169: `Data de validade do documento`,
  p170: `Data de entrada`,
  p171: `Data de saída`,
  p172: `Telefone`,
  p173: `Não foi possível escanear o seu documento.`,
  p174: `O endereço não corresponde a nenhuma reserva no sistema`,
  p175: `Informações do check-in`,
  p176: `Suporte`,
  p177: `Espanhol (Espanha)`,
  p178: `Inglês`,
  p179: `Árabe`,
  p180: `Documento de identidade`,
  p181: `Passaporte`,

  p182: `Selecione o parentesco`,
  p183: `Filho/Filha`,
  p184: `Avô/Avó`,
  p185: `Bisavô/Bisavó`,
  p186: `Bisneto/Bisneta`,
  p187: `Cunhado/Cunhada`,
  p188: `Cônjuge`,
  p189: `Irmão/Irmã`,
  p190: `Neto/Neta`,
  p191: `Outro`,
  p192: `Pai ou Mãe`,
  p193: `Sobrinho/Sobrinha`,
  p194: `Sogro/Sogra`,
  p195: `Tio/Tia`,
  p196: `Responsável legal`,
  p197: `Genro/Nora`,

  p198: `O campo parentesco é obrigatório`,
  p199: `Documento de identidade`,
  p200: `OUTRO`,
  p201: `Número de suporte do documento`,
  p202: `O número de suporte do documento é obrigatório`,

  p203: `Informação exigida pelo Decreto Real 933/2021`,
  p204: `Nos termos do Decreto Real 933/2021, de 26 de outubro, precisamos coletar dados como seu endereço, código postal, forma de pagamento e data de pagamento para cumprir as normas de segurança.`,
  p205: `Endereço residencial atual`,
  p206: `Endereço`,
  p207: `Código postal`,
  p208: `Forma de pagamento`,
  p209: `Selecione uma forma de pagamento`,
  p210: `Dinheiro`,
  p211: `Pagamento na chegada`,
  p212: `Cartão de crédito`,
  p213: `Pagamento por celular`,
  p214: `Plataforma de pagamento`,
  p215: `Vale-presente`,
  p216: `Transferência`,
  p217: `Data de pagamento`,
  p218: `Forma de pagamento`,
  p219: `Data de pagamento`,
  p220: "País de residência",
  p221: "Cidade de residência",
  p222: "Endereço residencial",
  p223: "Código postal residencial",

  p224: "Selecione uma opção",
  p225: "Há menores de idade na reserva?",
  p226: "Não",
  p227: "Sim",
  p228: "Documento não permitido",
  p229: "Por favor, verifique e use seu passaporte válido para continuar.",
  p230:`Escaneie seu passaporte ou documento de identidade`,

  p231: `A data de saída não pode ser anterior à data de chegada`,
  p232: `Endereço de e-mail válido`,
  p233: `Campo obrigatório`,
  p234: `O número do documento não é válido`,
  p235: `A data de saída não pode ser anterior à data de saída`,
  p236: `Você precisa indicar se há crianças na reserva`,
  p237: `Você precisa selecionar o parentesco quando há crianças na reserva`,
  p238: `Erro, não é possível continuar o processo`,
  p239: `Bem-vindo(a)!`,
  p240: `Tenha seu`,
  p241: `Documento de identidade ou Passaporte`,
  p242: `🪪 em mãos para o processo automatizado`,
  p243: `Atenção`,
  p244: `Aceitar as permissões de câmera 📷`,
  p245: `é necessário para que nosso scanner funcione corretamente`,
  p246: `Escaneie o verso do seu`,
  p247: `Faça aqui o registro do seu check-in!`,
  p248: `Link copiado para a área de transferência`,
  p249: `Registrar outro hóspede`,
  p250: `WhatsApp`,
  p251: `Copiar link`,
  p252: `Forma de pagamento desconhecida`,
  p253: `O código postal não foi encontrado nos registros`,
  p254: `Experiências e serviços`,
  p255: `Tudo o que você precisa para aproveitar ao máximo a sua estadia`,
};
